/*
 * @FilePath: index.js
 * @Author: chenwei
 * @Date: 2022-04-15 19:46:59
 * @LastEditors: chenwei
 * @LastEditTime: 2022-07-15 10:01:16
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
 */
import {post,get} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//新增新闻
export const addNews = p => post(proxyHeader+'service/common-service/news-center/save', p);

//编辑新闻
export const updateNews = p => post(proxyHeader+'service/common-service/news-center/update', p);

//分页查询新闻
export const getNews = p => get(proxyHeader+'service/common-service/news-center/list', p);

//分页查询新闻
export const deleteNews = p => post(proxyHeader+'service/common-service/news-center/delete', p);

//查询新闻详情
export const getDetail = p => get(proxyHeader+'service/common-service/news-center/info', p);
